// customToast.js
let toastContainer = null;

export function showCustomToast(message, type = 'info', duration = 3000) {
  if (!toastContainer) {
    toastContainer = document.createElement('div');
    toastContainer.className = 'custom-toast-container';
    document.body.appendChild(toastContainer);

    const style = document.createElement('style');
    style.innerHTML = `
      .custom-toast-container {
        position: fixed;
        bottom: 50px;
        left: 50%;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        z-index: 9999;
      }

      .custom-toast {
        padding: 12px 20px;
        border-radius: 8px;
        color: white;
        font-weight: 500;
        min-width: 200px;
        text-align: center;
        animation: fadeInUp 0.3s ease;
        opacity: 0.95;
      }

      .custom-toast-info {
        background-color: #007bff;
      }

      .custom-toast-success {
        background-color: #28a745;
      }

      .custom-toast-error {
        background-color: #dc3545;
      }

      .custom-toast-warning {
        background-color: #ff9800;
      }
        
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 0.95;
          transform: translateY(0);
        }
      }
    `;
    document.head.appendChild(style);
  }

  const toast = document.createElement('div');
  toast.className = `custom-toast custom-toast-${type}`;
  toast.innerHTML = message;

  toastContainer.appendChild(toast);

  setTimeout(() => {
    toast.remove();
  }, duration);
}
